import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss'
import TextDisplay from '/chat/src/components/TextDisplay'
import {toArray} from 'react-emoji-render';

class AutoMessage extends Component {
    render() {
        if(!this.props.automessage){
            return (
                <div className={style.HeaderNoAutoMessage}/>
            );
        }
        const message = this.props.automessage.getIn(['message', 'message'], '');

       return (
            <div className={style.HeaderAutoMessage}>
                 <TextDisplay text={message}/>
            </div>
        );
    }
}

export default AutoMessage;



// WEBPACK FOOTER //
// ./components/Header/AutoMessage/index.js